import EntityService from "./entity";

class ArticleService extends EntityService {
  constructor(name) {
    super(name)
  }
}

export default new ArticleService("article")




// WEBPACK FOOTER //
// ./src/services/article.js